// UI monolíngue por ora: o texto vem do bundle pt-BR direto, não do i18next
// (ver i18n/README.md — trocar o idioma padrão é trocar este caminho).
import type { LivenessErrorType } from '@/types/liveness';
import selfie from '@/i18n/locales/pt-BR/selfie.json';
export type { LivenessErrorType };

export const selfieCopy = {
  title: selfie.title,
  description: selfie.description,
  liveBadge: selfie.liveBadge,
  captureHint: selfie.captureHint,
  captureButtonLabel: selfie.captureButtonLabel,
  validationTitle: selfie.validationTitle,
  validationDescription: selfie.validationDescription,
  validationStatus: selfie.validationStatus,
  retryButton: selfie.retryButton,
  contactSupportButton: selfie.contactSupportButton,
  visualTips: [
    selfie.visualTips.lighting,
    selfie.visualTips.noAccessories,
    selfie.visualTips.lookAtCamera,
  ],
} as const;

export const simpleSelfieCopy = {
  title: selfie.simple.title,
  description: selfie.simple.description,
  captureHint: selfie.simple.captureHint,
  uploadButton: selfie.simple.uploadButton,
  cameraUnavailableTitle: selfie.simple.cameraUnavailableTitle,
  cameraUnavailableDescription: selfie.simple.cameraUnavailableDescription,
  uploadError: selfie.simple.uploadError,
  cameraRecovering: selfie.cameraRecovering,
} as const;

export const livenessErrorCopy: Record<
  LivenessErrorType,
  { title: string; description: string }
> = {
  poor_lighting: selfie.livenessErrors.poor_lighting,
  face_misaligned: selfie.livenessErrors.face_misaligned,
  timeout_abandon: selfie.livenessErrors.timeout_abandon,
  device_error: selfie.livenessErrors.device_error,
  liveness_access_denied: selfie.livenessErrors.liveness_access_denied,
  generic_liveness: selfie.livenessErrors.generic_liveness,
};
